module.exports = __webpack_public_path__ + "static/The_Chase_Vol_1-9a09faa261f1cb29ffd04447ecec4023.png";